export default "__VITE_ASSET___xR2zF_p__"